import StreamComponent from './StreamComponent';

function App() {
    return <StreamComponent />;
}

export default App;
